import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from 'src/app/shared/models/listing.model';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AgentService } from '../shared/services/agent.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'app-agent-representative-list',
  templateUrl: './agent-representative-list.component.html',
  styleUrls: ['./agent-representative-list.component.css']
})
export class AgentRepresentativeListComponent implements OnInit {

  private collection: Listing;
  pageSize =10;
  private itemsMenu: MenuItem[] = [];
  //#endregion
  @ViewChild('MyRepresentative',{static: false}) gridView: GridViewComponent;
  IsHtml: boolean = false;
  HasMenu:boolean =true;
  DomainUrl= AppConfig.settings.apiServer.DomainIntraUrl;
  SearchForm: FormGroup;
  searchName: any = '';
  user: User = new User();
  constructor(private agentSrv: AgentService, private global: GlobalServices,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,  private sanitized: DomSanitizer) {

    this.user = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    this.buildForm();
    //Enable Loader
    this.global.isLoaderEnabled = true;
    this.loadMyTasks(0, "UserName", "DESC");
  }

  buildForm() {
    this.SearchForm = this.formBuilder.group({
      SearchName: new FormControl(''),
    });
  }

  loadMyTasks(pPageIndex: number, pSortBy: string, pSortDirection: string) {
    this.searchName = this.SearchForm.controls.SearchName.value;
    this.agentSrv.RepresentativeList(pPageIndex, this.pageSize, this.searchName, pSortBy, pSortDirection,this.user.UserId).subscribe(
      //this.myTasksService.getPendingTasks("nashwa.mostafa@linkdev.com", pPageIndex, this.pageSize, pSortBy, pSortDirection).subscribe(
      data => {
        if (data.Success) {
          this.collection = data.Data,
            this.loadCollectionCompleted(pSortBy, pSortDirection)
        }
      }
    );
  }
  loadCollectionCompleted(pSortBy: string, pSortDirection: string) {
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      "AgentRepresentative/GetList?pageIndex={PAGEINDEX}&pageSize=" + this.pageSize + '&searchName=' + this.searchName +
      "&sortBy={SORTBY}&sortDirection={SORTDIR}",
      "SHARED.MYTASKS", this.itemsMenu, pSortBy, pSortDirection,"RepresentativeList");
    //Disable Loader
    this.global.isLoaderEnabled = false;
  }

  //   loadItemsMenu(collection?: any) {
  //     const currentCollection = collection || this.collection.Collection;
  //     if (currentCollection.length > 0)
  //       currentCollection.forEach((key: any) => {
  //       if (key.Status === AgentStatus.Active) {
  //         key.Action = this.sanitized.bypassSecurityTrustHtml(`<a class='btn btn-primary SCAcustomBtn inverse-btn' href="${this.DomainUrl}deactivateRepresentative/${key.RequestId}">Deactivate</a> `);
  //         this.itemsMenu[0] = new MenuItem();
  //         this.itemsMenu[0].Title = "Deactivate";
  //         this.itemsMenu[0].TitleAr = "الغاء التفعيل";
  //       }
  //       else {
  //         key.Action = this.sanitized.bypassSecurityTrustHtml(`<a  class='btn btn-primary SCAcustomBtn' href="${this.DomainUrl}activateRepresentative/${key.RequestId}">Activate</a>`);

  //         this.itemsMenu[0] = new MenuItem();
  //         this.itemsMenu[0].Title = "Acitvate";
  //         this.itemsMenu[0].TitleAr = "تفعيل";
  //       }


  //     });

  // }

  Activate(id:string){
    if (id) {
      window.open("#/activateRepresentative/"+id, '_blank');
    }
  }
  DeActivate(id:string){
    if (id) {
      window.open("#/deactivateRepresentative/"+id, '_blank');
    }
  }

  onSubmit() {

    this.global.isLoaderEnabled = true;
    this.searchName = this.SearchForm.value;
    this.loadMyTasks(0, "UserName", "DESC");;
  }
  reset() {
    this.SearchForm.controls.SearchName.setValue("");
    this.searchName = "";
  }
}

export class MenuItem {
  Title: string;
  TitleAr: string;
};

export enum AgentStatus {
  InActive = "InActive",
  Active = "Active"
};

